import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-file-alt mx-3" }, null, -1);
const _hoisted_2 = { class: "tag is-light is-rounded has-text-weight-bold ml-1" };
import { requestStatusLabels } from './model';
import { formatDate } from '@/core/utils';
import { canSeeFeature } from '@/core/session';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationBadge',
    props: {
        application: {}
    },
    setup(__props) {
        const applicationTypes = {
            "BIRTH_RECORD_APPLICATION": {
                label: (appl) => `${formatDate(appl.createdAt)} - Birth Record`,
                link: (appl) => `/birthRecords/${appl.id}`,
                enabled: () => canSeeFeature("birthRecords")
            },
            "GEORGIA_DFCS_BENEFITS_APPLICATION": {
                label: (appl) => `${formatDate(appl.createdAt)} - Georgia DFCS Benefits`,
                link: (appl) => `/georgiaBenefits/${appl.id}`,
                enabled: () => canSeeFeature("georgiaBenefits")
            },
            "SOCIAL_SECURITY_APPLICATION": {
                label: (appl) => `${formatDate(appl.createdAt)} - Social Security`,
                link: (appl) => `/socialSecurity/${appl.id}`,
                enabled: () => canSeeFeature("socialSecurity")
            },
            "ONLINE_SOCIAL_SECURITY_APPLICATION": {
                label: (appl) => `${formatDate(appl.createdAt)} - Social Security`,
                link: (appl) => `/socialSecurity/${appl.id}`,
                enabled: () => canSeeFeature("socialSecurity")
            },
        };
        const describeApplication = (appl) => { var _a, _b; return ((_a = applicationTypes[appl.type]) === null || _a === void 0 ? void 0 : _a.enabled()) && ((_b = applicationTypes[appl.type]) === null || _b === void 0 ? void 0 : _b.label(appl)); };
        const getApplicationLink = (appl) => { var _a; return (_a = applicationTypes[appl.type]) === null || _a === void 0 ? void 0 : _a.link(appl); };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (describeApplication(_ctx.application))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: getApplicationLink(_ctx.application)
                }, {
                    default: _withCtx(() => [
                        _hoisted_1,
                        _createTextVNode(" " + _toDisplayString(describeApplication(_ctx.application)) + " ", 1),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(requestStatusLabels)[_ctx.application.status]), 1)
                    ]),
                    _: 1
                }, 8, ["to"]))
                : _createCommentVNode("", true);
        };
    }
});
